import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import request from '@/utils/request';
export function login(_x, _x2, _x3, _x4, _x5, _x6) {
  return _login.apply(this, arguments);
}
function _login() {
  _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(loginName, password, code, uuid, source, partyId) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request({
            url: 'auth/login',
            method: 'post',
            data: {
              loginName: loginName,
              password: password,
              code: code,
              uuid: uuid,
              source: source,
              partyId: partyId
            }
          });
        case 3:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", null);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _login.apply(this, arguments);
}
export function getUserInfo() {
  return _getUserInfo.apply(this, arguments);
}
function _getUserInfo() {
  _getUserInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return request({
            url: 'auth/info',
            method: 'get'
          });
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", {
            roles: []
          });
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 6]]);
  }));
  return _getUserInfo.apply(this, arguments);
}
export function getCodeImg() {
  return request({
    url: 'auth/code',
    method: 'get'
  });
}
export function logout() {
  return request({
    url: 'auth/logout',
    method: 'delete'
  });
}

/**
 * 获取登录页面配置信息
 *
 * @param data {Object<{ domain: string }>}
 * @return {Promise<{backgroundUrl: null, pcLoginLogoUrl: null}>}
 */
export function getLoginConfig(_x7) {
  return _getLoginConfig.apply(this, arguments);
}
function _getLoginConfig() {
  _getLoginConfig = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(data) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return request({
            url: 'auth/pcLoginVo',
            method: 'post',
            data: data
          });
        case 3:
          return _context3.abrupt("return", _context3.sent);
        case 6:
          _context3.prev = 6;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", {
            backgroundUrl: null,
            pcLoginLogoUrl: null
          });
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 6]]);
  }));
  return _getLoginConfig.apply(this, arguments);
}